// extracted by mini-css-extract-plugin
export default {"adminPanel":"ZapleczeAdmin_adminPanel__liyPW","colory":"ZapleczeAdmin_colory__Qv+A7"};